/**
 * @file Web Galleries Favorite Photos View.
 */

import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import WebGalleryHeaderContainer from '../containers/WebGalleryHeaderContainer';
import WebGalleryFavoritePhotosContainer from '../components/WebGalleryFavoritePhotos/WebGalleryFavoritePhotosContainer';
import PhotoSelectorContextProvider from '../../../components/global/PhotoSelectorContext';

const WebGalleriesFavoritePhotosView = () => {
  return (
    <Fragment>
      <Helmet>
        <title>My Favorites &ndash; Waldo</title>
      </Helmet>

      <WebGalleryHeaderContainer />
      <div className="flex-auto">
        <PhotoSelectorContextProvider>
          <WebGalleryFavoritePhotosContainer />
        </PhotoSelectorContextProvider>
      </div>
    </Fragment>
  );
};

export default WebGalleriesFavoritePhotosView;
